<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {medicineCabinetApi} from "@/container";
import {MedicineCabinetCategoryRaw} from "@/core/interfaces/medicine-cabinet/MedicineCabinet";
import Loader from "@/core/components/base/spinner/Loader.vue";
import {useRouter} from "vue-router";

const router = useRouter();
const categories = ref<MedicineCabinetCategoryRaw[]>();
const loading = ref<boolean>(false);

onMounted(() => {
    loading.value = true;
    medicineCabinetApi().indexCategories({parent: true, prescription: false})
        .then(response => categories.value = response)
        .finally(() => loading.value = false);
});

const sections = computed(() => {
    const result: { title: string, data: MedicineCabinetCategoryRaw[] }[] = [];
    if (categories.value?.length) {
        categories.value.forEach(category => {
            if (category.children?.length) {
                result.push({title: category.name, data: category.children});
            } else {
                result.push({title: category.name, data: [category]});
            }
        });
    }

    return result;
});
</script>

<template>
  <div v-if="loading" class="flex flex-1 items-center justify-center">
    <Loader />
  </div>
  <div class="grid grid-cols-2">
    <div
      v-for="(category, index) in sections"
      :key="index"
    >
      <div class="p-5">
        <p class="font-weight-bold p-3 rounded-md">
          {{ category.title }}
        </p>
        <div
          v-for="item in category?.data"
          :key="`${category.title}-${item.id}`"
          class="flex my-4 rounded-lg bg-white shadow overflow-hidden cursor-pointer hover:opacity-75"
          :style="{boxShadow: `1px 1px 3px ${item.color}`}"
          @click="router.push({name: 'medicine-cabinet.categories.edit', params: {categoryId: item.id}})"
        >
          <div
            class="w-6"
            :style="{ backgroundColor: `${item.color}` }"
          />
          <div class="p-5 flex flex-1 justify-center items-center">
            <p> {{ item.name }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
